export class RegisterModel {
        public id: string;
        public patientREF: string;
        public userName: string;
        public titleId: string = null;
        public firstName: string;
        public middleName: string;
        public surName: string;
        public sexId: string = null;
        public sexName: string;
        public dateOfBirth: any;
        public email: string;
        public address1: string;
        public address2: string;
        public address3: string;
        public postcode: string;
        public countryId: string = null;
        public countryName: string;
        public homePhone: string;
        public workPhone: string;
        public mobilePhone: string;
        public countryOfBirthId: string = null;
        public countryOfBirthName: string;
        public occupationId: string = null;
        public partyTypeId: string;
        public partyTypeName: string;
        public partyId: string;
        public partyName: string;
        public college: string = null;
        public studentId: string;
        public healthInsuranceId: string = null;
        public healthPolicyNumber: string;
        public policyNumber: string;
        public marketingId: string = null;
        public isIncludeInMarketing: boolean;
        public isSeparateBillingAddress: boolean;
        public isDeceased: boolean;
        public isActive: boolean;
        public billingAddress1: string = '';
        public billingAddress2: string = '';
        public billingAddress3: string = '';
        public billingPostCode: string = '';
        public billingCountryId: string = null;
        public billingCountryName: string;
        public passportOrIdNumber: string;

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/register/register.model.ts